// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"e026d204","513":"ec567c9e","703":"0a045f06"}[chunkId] + ".chunk.js";
};